export default __webpack_public_path__ + "static/media/blackleftarrow.fad82c7e.svg";